






















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import env from '@/env';
import { Cutoverplan } from '@/interfaces/Cutoverplan';
import { Module } from '@/interfaces/Module';
import ApplyToExistingDialog from '@/components/Dialogues/ApplyToExistingDialog.vue';

@Component({
  components: { ApplyToExistingDialog }
})
export default class CloneCutoverplanDialog extends Vue {
  @Prop()
  cutoverplanId!: number;

  private dialog = false;

  private selectedModules: number[] = [];

  private cutoverplan?: Cutoverplan;

  private modules: Module[] = [];

  private copyResponsibles = true;

  private copyPhases = true;

  private createInitialChangelog = true;

  @Watch('dialog')
  watchDialog(value: boolean) {
    if (value) this.loadCutoverplan();
  }

  async loadCutoverplan() {
    const { data: cutoverplan } = await axios.get(
      `${env.backend_url}/cutoverplan/full/${this.cutoverplanId}`
    );

    this.cutoverplan = cutoverplan;
    this.selectedModules = this.cutoverplan?.modules.map((module) => module.id) || [];
    this.modules = this.cutoverplan?.modules || [];
  }

  async copy(cutoverplanId?: number | MouseEvent) {
    const id = typeof cutoverplanId === 'number' ? cutoverplanId : false;

    this.dialog = false;

    const cloneCutoverplanDto = {
      targetId: id,
      copyModuleIds: this.selectedModules,
      copyResponsibles: this.copyResponsibles,
      copyPhases: this.copyPhases,
      createInitialChangelog: this.createInitialChangelog,
      cutoverplanToCopyId: this.cutoverplanId
    };

    const { data } = await axios.post(`${env.backend_url}/cutoverplan/copy`, cloneCutoverplanDto);
    this.$router.push({ path: `/cutoverplan/${data.id}/` });
  }
}
